<form class="form-horizontal" #thisForm="ngForm" (ngSubmit)="submit()">
  <app-dados-boleta
    titulo="Dados da Boleta Compromissada de Compra"
    [operationDate]="model.operationDate"
    [id]="model.id"
    [accountManagerName]="model.accountManagerName"
    [accountManagerDocument]="model.accountManagerDocument"
    [statusDescription]="model.statusDescription"
  >
  </app-dados-boleta>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Tipo de Operação</div>
    <div class="card-body">
      <div class="col" [class.has-error]="hasError('operationTypeId')">
        <div
          class="form-check form-check-inline"
          *ngFor="let item of ListOperationTypesContracted; index as i"
        >
          <input
            class="form-check-input"
            data-cy="operationTypeId"
            type="radio"
            name="operationTypeId"
            id="{{ 'operationType-' + i + '-id' }}"
            [value]="item.id"
            [(ngModel)]="model.operationTypeId"
          />

          <label
            class="form-check-label"
            for="{{ 'operationType-' + i + '-id' }}"
          >
            {{ item.name }}
          </label>
        </div>
      </div>
    </div>
  </div>

  <app-dados-fundo
    #portfolio
    [canEdit]="canEdit()"
    [canValidate]="canValidate"
    [ticketType]="TicketTypeEnum.Contracted"
    [operationType]="model.operationTypeId"
    (emitterStockSelectedItem)="getStockSelectedFixedIncomeComitted($event)"
  ></app-dados-fundo>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados da Operação</div>
    <div class="card-body">
      <div class="row mb-2">
        <app-out-custody></app-out-custody>
      </div>
      <div class="row mb-2">
        <div class="col-3" [class.has-error]="hasError('unitPriceOutward')">
          <label>PU Ida</label>
          <input
            type="text"
            class="form-control"
            data-cy="unitPriceOutward"
            [(ngModel)]="model.unitPriceOutward"
            [textMask]="{ mask: validator.unitPriceMask }"
            name="unitPriceOutward"
            required
          />
        </div>
        <div class="col-3" [class.has-error]="hasError('unitPriceReturn')">
          <label>PU Volta</label>
          <input
            type="text"
            class="form-control"
            data-cy="unitPriceReturn"
            [(ngModel)]="model.unitPriceReturn"
            [textMask]="{ mask: validator.unitPriceMask }"
            name="unitPriceReturn"
            required
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-3" [class.has-error]="hasError('returnDate')">
          <label>Data de Retorno</label>
          <input
            placeholder="Select date"
            type="date"
            class="form-control col-10"
            name="returnDate"
            data-cy="returnDate"
            [(ngModel)]="model.returnDate"
            required
          />
        </div>
        <div class="col-3" [class.has-error]="hasError('valueOutward')">
          <label>Valor Ida</label>
          <input
            type="text"
            class="form-control"
            data-cy="valueOutward"
            name="valueOutward"
            [(ngModel)]="model.valueOutward"
            [textMask]="{ mask: validator.unitPriceMask }"
            required
          />
        </div>
        <div class="col-3" [class.has-error]="hasError('valueReturn')">
          <label>Valor Volta</label>
          <input
            type="text"
            class="form-control"
            data-cy="valueReturn"
            name="valueReturn"
            [(ngModel)]="model.valueReturn"
            [textMask]="{ mask: validator.unitPriceMask }"
            required
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="offset-6"></div>

        <div
          class="col-3"
          [class.has-error]="amount.invalid && (amount.dirty || amount.touched)"
        >
          <label>Quantidade</label>
          <input
            type="text"
            class="form-control"
            data-cy="amount"
            [(ngModel)]="model.amount"
            [textMask]="{ mask: validator.amountMask }"
            name="amount"
            #amount
          />
        </div>
        <div class="col-3" [class.has-error]="hasError('operationValue')">
          <label>Valor da Operação</label>
          <input
            type="text"
            class="form-control"
            data-cy="operationValue"
            name="operationValue"
            [(ngModel)]="model.operationValue"
            [textMask]="{ mask: validator.operationValueMask }"
            required
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-3" [class.has-error]="hasError('security')">
          <label>Nome do Título</label>
          <ng-select
            [searchable]="false"
            [(ngModel)]="selectedPublicSecurityType"
            [ngModelOptions]="{ standalone: true }"
            (change)="publicSecurityTypeSelected()"
            [disabled]="!canEdit()"
            required
          >
            <ng-option
              *ngFor="let item of publicSecurityTypes"
              [value]="item"
              >{{ item }}</ng-option
            >
          </ng-select>
        </div>

        <div class="col-3" [class.has-error]="hasError('securityId')">
          <label>Código Título</label>

          <ng-select
            [searchable]="false"
            [(ngModel)]="model.securityId"
            [ngModelOptions]="{ standalone: true }"
            (change)="publicSecurityIdSelected()"
            [disabled]="!canEdit()"
            required
          >
            <ng-option
              *ngFor="let publicSecurity of publicSecurityIdsList"
              [value]="publicSecurity"
              >{{ publicSecurity }}</ng-option
            >
          </ng-select>
        </div>

        <div class="col-3" [class.has-error]="hasError('expirationDate')">
          <label>Data Vencimento</label>

          <ng-select
            [searchable]="false"
            [(ngModel)]="selectedPublicSecurityItem"
            [ngModelOptions]="{ standalone: true }"
            (change)="publicSecurityItemSelected()"
            [disabled]="!canEdit()"
          >
            <ng-option
              *ngFor="let publicSecurity of publicSecurityList"
              [value]="publicSecurity"
              >{{ publicSecurity.expirationDate }}</ng-option
            >
          </ng-select>
        </div>
        <div class="col-3">
          <label>Taxa Emissão</label>
          <input
            type="text"
            class="form-control"
            name="issueTax"
            data-cy="issueTax"
            [(ngModel)]="model.issueTax"
            [textMask]="{ mask: validator.decimalFutureFeeMask }"
            required
          />
        </div>
      </div>
    </div>
  </div>

  <br />

  <app-counterpart
    #counterpart
    [ticketType]="TicketTypeEnum.Contracted"
    [canEdit]="canEdit()"
    [canValidate]="canValidate"
    [model]="this.model"
  >
  </app-counterpart>

  <app-annotation #annotation [annotation]="model.annotations"></app-annotation>

  <div class="actions" *ngIf="canEdit()">
    <input
      type="button"
      data-cy="submit"
      value="Salvar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="submit()"
      [debounceTime]="200"
    />
    <input
      type="button"
      data-cy="forward"
      value="Encaminhar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="forward()"
      [debounceTime]="200"
    />
    <input
      type="button"
      value="Cancelar"
      class="btn btn-danger me-2"
      [disabled]="!canCancel()"
      appDebounceClick
      (debounceClick)="cancel()"
      [debounceTime]="200"
    />
  </div>

  <div class="actions" *ngIf="canChangeStatus()">
    <input
      type="button"
      data-cy="approve"
      value="Aprovar"
      class="btn btn-success me-2"
      appDebounceClick
      (debounceClick)="approve()"
      [debounceTime]="200"
    />
    <input
      type="button"
      data-cy="reject"
      value="Reprovar"
      class="btn btn-danger me-2"
      appDebounceClick
      (debounceClick)="reject()"
      [debounceTime]="200"
    />
  </div>

  <div class="actions" *ngIf="canDuplicate()">
    <input
      type="button"
      data-cy="duplicate"
      value="Duplicar"
      class="btn btn-primary me-2"
      [disabled]="!model.id"
      appDebounceClick
      (debounceClick)="duplicate()"
      [debounceTime]="200"
    />
  </div>
</form>

<app-workflow-history
  [ticketId]="model.id"
  [refresh]="dataChanged"
></app-workflow-history>
